//  These are the 4 header patterns that this directive supports:
//  1. Logo only (currently only used for PNC post-lead authorization page)
//  2. Logo + header blurb + login link + icon badge
//  3. Logo + header links (e.g. "FAQ", "Contact Us") + login link + icon badge
//  4. Logo + header links + header dropwdown menu + icon badge
//
//  #1-3 are only in effect when the user is unauthenticated, and the login link
//    is conditionally hidden on /login and /myoffer pages
//  #4 is used in the customer application for rates_terms and beyond.
//
//  Attribute details:
//    aboutLink: [optional]  href value for about link
//    aboutText: [optional]  text clicked on to go to about page
//    badgeAlt: [optional] alt tag for right-side badge image
//    badgeSrc: [optional] path to right-side badge image
//    blurbText: [optional] used on myoffer pages when only a login link is present in header
//    contactModal: [required] name of the contact us modal to use
//    contactText: [required] text clicked on to open contact us modal (usually "Contact Us")
//    faqLink: [optional] href value for FAQ link
//    faqText: [optional] text clicked on to go to FAQ page
//    isHomePage: [optional] needed to hide the login link on the home page
//    isMyOffer: [optional] needed to hide the login link on the myoffer page
//    isPostLead: [required] an ivar passed in from the controller (@is_partner_post_lead)
//    logoSrc: [required] path to logo image
//    logoAlt: [required] alt text for logo image
//    menuAnchorText: [required] text clicked on to open dropdown menu
//
//  NOTE: Currently blurbs are incompatible with about, contact, and faq links
//
//  Example usage:
//    <amount-header
//      blurb-text="Already have an account?"
//      contact-modal="contact_us"
//      contact-text="Contact Us"
//      is-post-lead="false"
//      is-my-offer="false"
//      logo-alt="Bank logo link to home page"
//      logo-src="images/logo.jpg"
//      menu-anchor-text="My Account"
//    ></amount-header>

const amountHeader = () => {
  return {
    restrict: "E",
    template: require("./template.html"),
    scope: {
      aboutLink: "@",
      aboutText: "@",
      blurbText: "@",
      contactModal: "@",
      contactText: "@",
      isMyOffer: "=",
      isPostLead: "=",
      logoSrc: "@",
      logoAlt: "@",
      menuAnchorText: "@",
    },
    link: (scope, element) => {
      scope.openContactModalFromHeader = () => {
        scope.modalConfig = { aria_label: scope.contactText };
        scope.$emit("amountModal:open", scope.contactModal, scope.modalConfig);
      };

      scope.openHeaderDrawer = () => {
        // Capture header anchor to return focus when dropdown is closed (WCAG requirement)
        scope.activeElement = document.activeElement;
        // Focus first element in dropdown (WCAG requirement)
        scope.$broadcast("amountTrapFocus:reset", scope.activeElement);

        scope.drawer.addClass("header__drawer--open");
        scope.caretDirection = "up";
      };

      scope.closeHeaderDrawer = () => {
        scope.drawer.removeClass("header__drawer--open");
        scope.caretDirection = "down";
        scope.activeElement.focus();
      };

      scope.toggleHeaderDrawer = () => {
        if (scope.drawer.hasClass("header__drawer--open")) {
          scope.closeHeaderDrawer();
        } else {
          scope.openHeaderDrawer();
        }
      };

      scope.userIsAuthenticated = () => {
        return scope.$parent.userIsAuthenticated();
      };

      scope.drawer = element.find(".header__drawer");
      scope.caretDirection = "down";
      scope.$on("amountTrapFocus:close", () => scope.closeHeaderDrawer());
      scope.$on("amountHeaderDrawer:close", () => scope.closeHeaderDrawer());
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountHeader", amountHeader);
